import http from 'utils/http';
import {
  AddColumnRequest,
  AddRowRequest,
  AppendCsv,
  ColumnResponse,
  RowsRequest,
  UpdateCellRequest,
  WorksheetRequest,
  WorksheetResponse
} from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import {
  appendCsvUrl,
  getAddColumnUrl,
  getAddCRowUrl,
  getColumnsUrl,
  getDeleteColumnUrl,
  getDeleteRowUrl,
  getRowsUrl,
  getWorkflowUrl,
  getWorksheetsUrl,
  getWorksheetUrl,
  importCsvUrl,
  UpdateCellUrl,
  UpdateColumnUrl,
  UpdateRowUrl,
  workflowExecuteUrl
} from './apiUrls';

export function getWorksheets(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{ data: WorksheetResponse[]; meta: MetaApiResponse }> {
  return http.get(getWorksheetsUrl(workspaceId, agentId), params);
}

export function getWorksheet(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  params?: Record<string, any>
): Promise<WorksheetResponse> {
  return http.get(getWorksheetUrl(workspaceId, agentId, worksheetId), params);
}

export function getColumns(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  params?: any
): Promise<{ data: ColumnResponse[]; meta: MetaApiResponse }> {
  return http.get(getColumnsUrl(workspaceId, agentId, worksheetId), params);
}

export function createWorksheet(workspaceId: string, agentId: string): Promise<any> {
  return http.post(getWorksheetsUrl(workspaceId, agentId));
}

export function AddColumn(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  payload: AddColumnRequest
): Promise<any> {
  return http.post(getAddColumnUrl(workspaceId, agentId, worksheetId), payload);
}

export function AddRow(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  payload: AddRowRequest
): Promise<any> {
  return http.post(getAddCRowUrl(workspaceId, agentId, worksheetId), payload);
}

export function UpdateCell(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  columnId: any,
  rowId: any,
  payload: UpdateCellRequest
): Promise<any> {
  return http.put(UpdateCellUrl(workspaceId, agentId, worksheetId, columnId, rowId), payload);
}

export function UpdateColumn(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  columnId: string,
  payload: object
): Promise<any> {
  return http.put(UpdateColumnUrl(workspaceId, agentId, worksheetId, columnId), payload);
}

export function UpdateRow(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  rowId: string,
  payload: object
): Promise<any> {
  return http.put(UpdateRowUrl(workspaceId, agentId, worksheetId, rowId), payload);
}

export function updateWorksheet(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  payload: WorksheetRequest
): Promise<any> {
  return http.put(getWorksheetUrl(workspaceId, agentId, worksheetId), payload);
}

export function deleteWorksheet(workspaceId: string, agentId: string, worksheetId: string): Promise<any> {
  return http.delete(getWorksheetUrl(workspaceId, agentId, worksheetId));
}

export function deleteColumn(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  columnId: string
): Promise<any> {
  return http.delete(getDeleteColumnUrl(workspaceId, agentId, worksheetId, columnId));
}

export function deleteRow(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  payload: RowsRequest
): Promise<any> {
  return http.delete(getDeleteRowUrl(workspaceId, agentId, worksheetId), payload);
}

export function exucuteWorkflow(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  payload: { rowrow_idId?: number | number[]; column_id: number; limit: string }
): Promise<any> {
  return http.post(workflowExecuteUrl(workspaceId, agentId, worksheetId), payload);
}

export function importCsv(workspaceId: string, agentId: string, worksheetId: string, payload: FormData): Promise<any> {
  return http.post(importCsvUrl(workspaceId, agentId, worksheetId), payload);
}

export function appendCsv(workspaceId: string, agentId: string, worksheetId: string, payload: AppendCsv): Promise<any> {
  return http.post(appendCsvUrl(workspaceId, agentId, worksheetId), payload);
}

export function getWorkflow(workspaceId: string): Promise<any> {
  return http.get(getWorkflowUrl(workspaceId));
}

export function getFilteredRows(
  workspaceId: string,
  agentId: string,
  worksheetId: string,
  params: Record<string, any>
): Promise<{ data: WorksheetResponse[]; meta: MetaApiResponse }> {
  const url = getRowsUrl(workspaceId, agentId, worksheetId);
  return http.get(url, params);
}
